module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-BoldItalic-webfont.svg
// module id = 376
// module chunks = 0